import React from 'react';
import './index.scss';

import QuestionMarkIcon from 'components/atoms/Icon/QuestionMarkIcon';


const SpPopUp = ({
  title,
  children
}) =>{
  return(
    <span className="SpPopUp">
      <QuestionMarkIcon/>
      <div className="popUpArea">
        <div className="popUpWrapper">
          <div className="popUpContent">
            <div className="PopUp-Title">
              {title}
            </div>
            <div className="PopUp-Detail">
              {children}
            </div>
          </div>          
          {/* <div className="popUpArrowArea">
            <div className="downArrow"/>
          </div> */}
        </div>
      </div>
    </span>
  );
};
export default SpPopUp;